var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"z-75 right-0 fixed flex flex-col items-end mr-6",class:[_vm.isSubpage ? 'top-28' : 'top-36']},[_c('FeedbackButton'),_vm._v(" "),_vm._t("page__actions")],2)}
var staticRenderFns = []

export { render, staticRenderFns }